<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <span class="configurationBannerLabel">Accessories</span>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationOptions">
        <div class="configurationDetailRow">
          @if (ballValveSelection) {
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Ball Valve:</span>
              <select
                class="halfWidthInputField"
                #ballValveInput
                [class.invalidConfigurationSelection]="isInvalidSelection(ballValveSelection.Name)"
                (change)="selectionChanged(ballValveSelection, ballValveInput.value)"
                [value]="ballValveSelection.Value.toString()">
                @for (allowable of ballValveSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid"
                    class="configurationSelectionOption"
                    [selected]="ballValveSelection.Value && ballValveSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">
                    {{ allowable.Description }}
                  </option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (hoseKitsSelection) {
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Hose Kits:</span>
              <select
                class="halfWidthInputField"
                #hoseKitsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(hoseKitsSelection.Name)"
                (change)="selectionChanged(hoseKitsSelection, hoseKitsInput.value)"
                [value]="hoseKitsSelection.Value.toString()">
                @for (allowable of hoseKitsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid"
                    class="configurationSelectionOption"
                    [selected]="hoseKitsSelection.Value && hoseKitsSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">
                    {{ allowable.Description }}
                  </option>
                }
              </select>
            </span>
          }
        </div>
        @if (controlsSelection) {
          <div class="configurationDetailRow">
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Controls:</span>
              <select
                class="halfWidthInputField"
                #controlsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(controlsSelection.Name)"
                (change)="selectionChanged(controlsSelection, controlsInput.value)"
                [value]="controlsSelection.Value.toString()">
                @for (allowable of controlsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid"
                    class="configurationSelectionOption"
                    [selected]="controlsSelection.Value && controlsSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">
                    {{ allowable.Description }}
                  </option>
                }
              </select>
            </span>
          </div>
        }
        <div class="configurationDetailRow">
          @if (waterValveSelection) {
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Water Valve:</span>
              <select
                class="halfWidthInputField"
                #waterValveInput
                [class.invalidConfigurationSelection]="isInvalidSelection(waterValveSelection.Name)"
                (change)="selectionChanged(waterValveSelection, waterValveInput.value)"
                [value]="waterValveSelection.Value.toString()">
                @for (allowable of waterValveSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid"
                    class="configurationSelectionOption"
                    [selected]="waterValveSelection.Value && waterValveSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">
                    {{ allowable.Description }}
                  </option>
                }
              </select>
            </span>
          }
        </div>
      </div>
    </div>
  }
</div>
